const SCHEMAS = {
  AVAILABILITIES: {
    LIMITED_AVAILABILITY: 'https://schema.org/LimitedAvailability',
    PRE_SALE: 'https://schema.org/PreSale',
    SOLD_OUT: 'https://schema.org/SoldOut',
    IN_STOCK: 'https://schema.org/InStock',
    DISCONTINUED: 'https://schema.org/Discontinued',
  },
};

export default SCHEMAS;
